import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import FindDesignView from '../views/FindDesignView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'find-design',
    component: FindDesignView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
